import en from '@/locale/en.json'
import fr from '@/locale/fr.json'

// TECH_DEBT: i18n_coverage_incomplete [DF-2954]
// i18n coverage is incomplete. The toast/error display strings catalogued in
// reviews/hardcoded-ui-strings-2026-06-02.md were moved into en.json (via
// getErrorMessage()/getMessage()), but a large body of user-facing text is still
// hard-coded: JSX prose, <Button label="...">, input placeholders and <Alert>
// copy across components (e.g. PassCodeGenerator), plus strings in non-component
// modules (services/utils/state/hooks) and throw new Error()/console.* diagnostics.
// The latter cannot use react-intl today because there is no standalone createIntl
// instance — only useIntl() inside components; localizing them needs a non-React
// createIntl(cache) wired to the localization store. See DF-2954 for the staged
// follow-up plan.
export const selectedLocale = 'en'
export const messages = {
  en,
  fr
}
